import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useSetUserPassword() {
  return useMutation({
    mutationFn: ({ userId, password }: { userId: string; password: string }) =>
      http.post(`/user/${userId}/set-password`, { password }).then((res) => res.data),
  });
}
